// import { useSelector } from "react-redux";
import styled, { css } from "styled-components";
import OrganismHeader from "Components/Organisms/Header";
import OrganismFooter from "Components/Organisms/Footer";
import OrganismNowTiles from "Components/Organisms/NowTiles";

// import * as Types from "Types";
const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;
const HeaderWrap = styled.div`
   display: flex;
   justify-content: center;
   width: 100%;
   padding: 0px 15px;
   box-sizing: border-box;
`;

const cssHeader = css`
   width: 100%;
   max-width: 1200px;
`;

const cssNowTiles = css`
   margin: 20px 0px;
`;

const NowTiles = styled(OrganismNowTiles)`
   min-height: calc(100vh - 110px - 144px - 97px);
`;

const Footer = styled(OrganismFooter)`
   margin-top: 110px;
`;

export default function Nows() {
   // const width = useSelector(({ dimensions }: Types.State) => dimensions.width);

   return (
      <Wrap>
         {/* {styles.shows({ width, sizes: { s: false, xs: false } }) && <OrganismMenuList css={MenuCss}></OrganismMenuList>} */}
         <HeaderWrap>
            <OrganismHeader css={cssHeader}></OrganismHeader>
         </HeaderWrap>
         <NowTiles css={cssNowTiles}></NowTiles>
         <Footer></Footer>
      </Wrap>
   );
}
